import type { ReactNode } from 'react'

type SettingsPanelShellProps = {
  /** Panel title shown at the top of the content column (e.g. "Preferences", "Subscription"). */
  title: string
  /** Optional controls aligned to the right of the title (e.g. "Browse all plans"). */
  titleTrailing?: ReactNode
  children: ReactNode
}

/**
 * Lightweight per-section header + content. The FE-827 SettingsModal shell owns the scroll container,
 * horizontal padding, and max-width centering, so this only supplies the section title (which reads as
 * a global setting, distinct from matter-scoped context) above the panel's reused content.
 */
export function SettingsPanelShell({ title, titleTrailing, children }: SettingsPanelShellProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* min-h-8 centers the title in the same 32px row the side-nav's top label uses, so they align. */}
      <div className="flex min-h-8 items-center justify-between gap-3">
        <h2 className="font-rethink-sans text-xl font-semibold leading-7 text-brand-neutral-950">{title}</h2>
        {titleTrailing}
      </div>
      {children}
    </div>
  )
}
